import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const versionSlice = createSlice({
  name: 'version',
  initialState: {
    clientVersion: '',
    serverVersion: ''
  },
  reducers: {
    setClientVersion(state, action: PayloadAction<string>) {
      state.clientVersion = action.payload
    },
    setServerVersion(state, action: PayloadAction<string>) {
      state.serverVersion = action.payload
    }
  }
})

export const { setClientVersion, setServerVersion } = versionSlice.actions
